export const SUPPORTED_LOCALES = ['it', 'en', 'cs', 'ro', 'bg', 'de', 'hu', 'pl', 'fr', 'ru', 'sk'] as const

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

function getPageLocale(): string {
  const defaultLocale = 'it';
  if (typeof window !== 'undefined') {
    const pathSegments = window.location.pathname.split('/');
    const locale = pathSegments[1];
    return (SUPPORTED_LOCALES as readonly string[]).includes(locale) ? locale : defaultLocale;
  }

  return defaultLocale;
}

function getLocalizedSlug(
  pathnames: Record<string, string>,
  locale: string,
): string {
  const localizedPath = pathnames[locale] ?? pathnames.it
  return localizedPath.replace(/^\//, '')
}

export { getLocalizedSlug }
export default getPageLocale
